export const COMPLEXITY_OPTIONS = [
	{ label: 'Easy', value: 'easy' },
	{ label: 'Medium', value: 'medium' },
	{ label: 'Hard', value: 'hard' }
];

export const PRIORITY_OPTIONS = [
	{ label: 'Low', value: 'low' },
	{ label: 'Medium', value: 'medium' },
	{ label: 'High', value: 'high' },
	{ label: 'Urgent', value: 'urgent' }
];

export const STATUS_OPTIONS = [
	{ label: 'Ready', value: 'ready' },
	{ label: 'In progress', value: 'in-progress' },
	{ label: 'Review', value: 'review' },
	{ label: 'Completed', value: 'completed' }
];
